import { UseQueryResult, useQuery } from "react-query";
import { getProfitMetricsRequest } from "../../../../entities/metrics/api/get-profit-metrics";
import { ProfitMetricDTO } from "../../../../entities/metrics/model/profit.model";
import { isCalendarDateRangeValid, toInclusiveTimestampRange } from "../../../../shared/lib/date-range";

export interface UseGetProfitMetricsProps {
  startDate: Date;
  endDate: Date;
  enabled: boolean;
}

export const queryKeys = {
  getProfitMetrics: (props: { start_date: string; end_date: string }) => ["getPericiasMetrics", props]
};

export function useGetProfitMetrics(props: UseGetProfitMetricsProps): UseQueryResult<ProfitMetricDTO[]> {
  const hasValidRange = isCalendarDateRangeValid({ start: props.startDate, end: props.endDate });
  const range = hasValidRange
    ? toInclusiveTimestampRange({ start: props.startDate, end: props.endDate })
    : { start: "", end: "" };
  const args = {
    start_date: range.start,
    end_date: range.end
  };

  return useQuery(queryKeys.getProfitMetrics(args), () => getProfitMetricsRequest(args), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled: props.enabled && hasValidRange
  });
}
